import { applyMiddleware, createStore, compose } from 'redux'

import { routerMiddleware } from 'react-router-redux'
import { browserHistory } from 'react-router'
import thunk from 'redux-thunk'
import rootReducer from 'reducers/index'

/**
 * Configures store for development
 * @param {Object} preloadedState - aplication initial state
 * @return {Object} store
 */
const configureStore = (preloadedState) => {
  // Sets store's middlewares
  const middleware = applyMiddleware(thunk, routerMiddleware(browserHistory))

  // Enables store on devTools
  const enhancers = compose(
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f
  )

  // Creates store
  const store = createStore(
    rootReducer,
    preloadedState,
    compose(middleware, enhancers)
  )

  const reducers = './../reducers'

  // Enables hot reloading whenever a reducer changes
  if (module.hot) {
    module.hot.accept(reducers, () => {
      const nextRootReducer = require(`${reducers}`).default // eslint-disable-line
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}

export default configureStore
